import { AppUpdateCard } from './AppUpdateCard';
import { EasyWorshipCard } from './EasyWorshipCard';
import { MonitorsCard } from './ProjectButtons';
import { ThemeEditor } from './ThemePage';

/**
 * Configuración de la app KEORA Multimedia (el engrane del menú): en qué monitor va cada pantalla
 * y cómo se ven (logo del botón «Logo», fuente, tamaño, color y posición del texto), además de
 * importar la biblioteca de EasyWorship de esa computadora.
 */
export function SettingsPage() {
  return (
    <div className="page page--narrow">
      <header className="page__header">
        <h1>Configuración</h1>
        <p className="muted">Los monitores son de esta computadora; el tema vale para todas las presentaciones de la iglesia.</p>
      </header>
      <AppUpdateCard />
      <MonitorsCard />
      <EasyWorshipCard />
      <h2>Cómo se ven las pantallas</h2>
      <ThemeEditor />
    </div>
  );
}
